import brazilStatess from 'Enums/brazilStates'
import { getCitiesByStateId } from 'Api/locationApi'

const state = {
  requesting: {
    cityList: false,
  },

  stateList: brazilStatess.toList('id', 'name'),
  cityList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_city_list(state, cityList) {
    state.cityList = cityList
  },
}

const actions = {
  async getCityList({ commit }, stateId) {
    commit('request_start', 'cityList')

    try {
      const { data } = await getCitiesByStateId(stateId)

      commit('set_city_list', data)
      commit('request_success', 'cityList')

      return data
    } catch (err) {
      commit('request_failure', 'cityList')

      throw err
    }
  }
}

export default {
  namespaced: true,

  state,
  actions,
  mutations
}